/*$(document).ready(function(){
  $('.company-list').slick({
    infinite: true,
    arrows: false,
    swipe: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    slidesToShow: 8,
    cssEase: "linear",
    responsive: [
          {
          breakpoint: 1200,
            settings: {
                centerMode: false,
                slidesToShow: 5,
            }
          },
          {
          breakpoint: 750,
            settings: {
                centerMode: false,
                slidesToShow: 3,
            }
          }
      ]
  });
});*/

// CTA用JS
$('.button_close').on('click', function () {
    $('.cta').addClass('disabled');
});